import { createContext, ReactNode } from 'react';

import { useResizeDetector } from 'react-resize-detector';

/**
 * Контекст для предоставления ширины корневого контейнера его потомкам.
 */
export const RootWidthContext = createContext<number | undefined>(undefined);

const DESKTOP_WIDTH_DEFAULT = 1024;

/**
 * Свойства компонента {@link RootWidthContextProvider}
 */
interface RootWidthContextProviderProps {
  /**
   * Дочерние элементы, которые будут отображены внутри провайдера.
   */
  children: ReactNode | ReactNode[];

  /**
   * Имя страницы, влияющее на логику определения ширины.
   */
  page?: string;
}

/**
 * Компонент-провайдер для RootWidthContext, который использует `react-resize-detector` для измерения ширины корневого контейнера.
 *
 * @public
 * @param children - Дочерние элементы, которые будут отображены внутри провайдера.
 * @param page - Имя страницы, влияющее на логику определения ширины.
 * @returns Компонент RootWidthContextProvider, который предоставляет контекст ширины корневого контейнера.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link RootWidthContextProviderProps}
 */
export const RootWidthContextProvider = ({
  children,
  page,
}: RootWidthContextProviderProps) => {
  const { width, ref } = useResizeDetector<HTMLDivElement>();

  if (page === 'sideMenu') {
    return (
      <RootWidthContext.Provider value={DESKTOP_WIDTH_DEFAULT}>
        {children}
      </RootWidthContext.Provider>
    );
  }

  if (page === 'header') {
    return (
      <div style={{ width: '100%' }}>
        <RootWidthContext.Provider value={DESKTOP_WIDTH_DEFAULT}>
          {children}
        </RootWidthContext.Provider>
      </div>
    );
  }

  return (
    <div ref={ref} id="sizeme" style={{ width: '100%' }}>
      <div
        style={
          {
            containerType: 'inline-size',
            width: width,
          } as Record<string, string | number>
        }
      >
        <RootWidthContext.Provider value={width}>
          {children}
        </RootWidthContext.Provider>
      </div>
    </div>
  );
};
